
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"45","height":"45","rx":"22.5","fill":"#D32F2F"}}),_c('path',{attrs:{"d":"M24.833 22.5l-4.083 2.333v-4.666l4.083 2.333z","fill":"#fff","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.833 23.325v-1.651c0-3.378 0-5.067 1.056-6.153 1.057-1.087 2.72-1.134 6.047-1.229 1.575-.044 3.185-.075 4.564-.075 1.378 0 2.988.031 4.564.075 3.326.095 4.99.142 6.046 1.229 1.057 1.086 1.057 2.777 1.057 6.153v1.65c0 3.38 0 5.068-1.056 6.155-1.057 1.086-2.72 1.134-6.047 1.227-1.575.046-3.185.077-4.564.077-1.522-.004-3.043-.03-4.564-.077-3.326-.093-4.99-.14-6.047-1.227-1.056-1.087-1.056-2.777-1.056-6.153v-.001z","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    